// store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 只管理是否需要刷新的标志
    needRefresh: false,
    taskListType: '',
    paySuccess: false
  },
  mutations: {
    // 设置刷新状态
    SET_NEED_REFRESH(state, payload) {
      if (typeof payload === 'object' && payload !== null) {
        state.needRefresh = payload.status
        state.taskListType = payload.type || ''
        return
      }
      state.needRefresh = payload
    },
    SET_TASK_LIST_TYPE(state, type) {
      state.taskListType = type || ''
    },
    // 设置支付成功状态
    SET_PAY_SUCCESS(state, status) {
      state.paySuccess = status
    }
  },
  actions: {
    // 触发刷新的动作 (可以在二级路由中 dispatch)
    triggerListRefresh({ commit }, type) {
      // 先清空再设置，确保连续提交同类型任务也能触发 watcher
      commit('SET_NEED_REFRESH', { status: false, type: '' })
      commit('SET_NEED_REFRESH', { status: true, type })
    }
  },
  getters: {
    needRefresh: state => state.needRefresh
  }
})
